export const LOGIN_PENDING = 'LOGIN_PENDING';
export const LOGIN_FULFILLED = 'LOGIN_FULFILLED';
export const LOGIN_REJECTED = 'LOGIN_REJECTED';

export const SELF_PENDING = 'SELF_PENDING';
export const SELF_FULFILLED = 'SELF_FULFILLED';
export const SELF_REJECTED = 'SELF_REJECTED';

export const LOGOUT = 'LOGOUT';
